import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import EditCompanyInfoForm from "./EditCompanyInfoForm";
import editIcon from "./../../images/editIconBlue.svg";
import "./prospectingDetailsPage.scss";
import Service from "../../services";
import { sendPhondNumberFormat } from "../../utils/GeneralUtils";


function EditCompanyInfo(props: any) {
  const [editCompanyModal, setEditCompanyModal] = useState(Boolean);
  const service = new Service();

  const toggleEditCompanyModal = () => setEditCompanyModal((prev) => !prev);
  // const handleFormSubmit = (e:any) => {
  //   e.preventDefault();

  // }

  const handleFormSubmit = (e: any, formValues: any) => {
    e.preventDefault();
    const data = {
      screen: "ProspectTR",
      sections: "UpdateBusinessInfoByName",
      isJsonReturnObject: false,
      data: {
        clientId: props.clientId,
        clientBusinessInfoId: formValues?.clientBusinessId,
        title: formValues?.title || null,
        businessEmail: formValues?.businessEmail || null,
        businessEmailType: formValues?.businessEmailType || null,
        businessPhoneNumber: sendPhondNumberFormat(formValues?.businessPhoneNumber) || null,
        businessPhoneExt: formValues?.businessPhoneExt || null,
        businessPhoneType: formValues?.businessPhoneType || null,
        businessName: formValues?.businessName || null,
        // productId: "e7bfc71a-2d13-11ee-be56-0242ac120002", 
        businessStreetAddress: formValues?.businessStreetAddress || null,
        businessUnitSuite: formValues?.businessUnitSuite || null,
        businessCity: formValues?.businessCity || null,
        businessState: formValues?.businessState || null,
        businessZipcode: formValues?.businessZipCode || null,
        industryType: formValues?.industryType || null,
        industrySubType: formValues?.industrySubType || null
      }
    };
    service
      .UpdateBusinessInfoByName(data)
      .then((response: any) => {
        toggleEditCompanyModal()
        props?.getLeadData && props?.getLeadData();
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  return (
    <div className="edit-link">
      {props?.trackerName === "LORATrackers" && (
        <div onClick={() => toggleEditCompanyModal()}>
          <img src={editIcon} alt="Edit Icon" className="icon" />
          Edit
        </div>)}
      <Modal
        className="editCompanyIfo-modal"
        isOpen={editCompanyModal}
        toggle={toggleEditCompanyModal}
      >
        <ModalHeader toggle={toggleEditCompanyModal} className="header-name">
          Edit Company Info
        </ModalHeader>
        <EditCompanyInfoForm
          toggleHandle={toggleEditCompanyModal}
          title={"Edit Company Info"}
          handleFormSubmit={handleFormSubmit}
          data={props?.data || {}}
        />
      </Modal>
    </div>
  );
}

export default EditCompanyInfo;
